<template>
  <el-dialog
    title="实体选择"
    v-dialogDrag
    :visible.sync="dialogVisible"
    class="mid-dialog"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-row class="mb-10px flex">
      <el-input
        placeholder="请输入"
        class="inline-block"
        prefix-icon="el-icon-search"
        v-model="treeKeyWords"
        clearable
      />
      <el-button type="primary" class="ml-6px" @click="searchTree">搜索</el-button>
    </el-row>
    <el-row class="tree-box">
      <el-tree
        highlight-current
        show-checkbox
        :data="treeData"
        :props="defaultProps"
        ref="treeRef"
        node-key="className"
        :filter-node-method="treeFilterMethod"
        @check="checkNode"
        class="min-h-300px max-h-full overflow-auto"
      >
      </el-tree>
    </el-row>
    <template #footer>
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="saveSelected">保存</el-button>
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'selecteTable',
  props: {
    visible: {
      type: Boolean,
      default: false,
    }, // 弹窗显隐
    treeListData: {
      type: Array,
      default: () => {
        return []
      },
    }, // 目录树数据
    isSingleChoice: {
      type: Boolean,
      default: false,
    }, // 是否单选
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  created() {
    this.treeData = [...this.treeListData]
  },
  data() {
    return {
      treeKeyWords: '', // 目录树搜索关键字
      treeData: [], // 目录树数据
      defaultProps: {
        children: 'none', // 没有子节点
        label: 'className',
      }, // 目录树默认配置
      currentCheckedLength: 0, // 当前目录树选中节点个数
      selectedNodeList: [], // 目录树已勾选节点
    }
  },
  methods: {
    /**
     * @description 目录树搜索
     */
    searchTree() {
      this.$refs.treeRef.filter(this.treeKeyWords)
    },

    /**
     * @description 目录树过滤
     */
    treeFilterMethod(value, data) {
      if (!value) return true
      return data.className && data.className.indexOf(value) !== -1
    },

    /**
     * @description 目录树节点勾选
     */
    checkNode(currentData, checkedNode) {
      const isCheck = checkedNode.checkedKeys.length > this.currentCheckedLength
      if (this.isSingleChoice) {
        // 单选，先清空之前的勾选
        _.forEach(this.selectedNodeList, (item) => {
          this.$refs.treeRef && this.$refs.treeRef.setChecked(item.className, false)
        })
        this.selectedNodeList = []
      }
      if (isCheck) {
        this.selectedNodeList = [{ ...currentData }]
      } else {
        this.selectedNodeList = []
      }
    },

    /**
     * @description 前端记录选择项
     */
    saveSelected() {
      if (!this.selectedNodeList.length) {
        this.$message.warning('当前未选择数据')
        return
      }
      this.$emit('getSelectedList', [...this.selectedNodeList])
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>

.tree-box {
  height: calc(100% - 46px);
}

</style>
